import { render, staticRenderFns } from "./multipleLimit-editor.vue?vue&type=template&id=088d9185&scoped=true&"
import script from "./multipleLimit-editor.vue?vue&type=script&lang=js&"
export * from "./multipleLimit-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088d9185",
  null
  
)

export default component.exports